import { combineReducers } from "redux";

// Import custom components
import loginReducer from "./loginReducer";
import headerReducer from "./headerReducer";
import assetLibReducer from "./assetLibReducer";
import assetUploadReducer from "./assetUploadReducer";
import dealRoomReducer from "./dealRoomReducer";
import dealRoomUploadReducer from "./dealRoomUploadReducer";
import crmReducer from "./crmReducer";
import chatAiReducer from "./chatAiReducer";
import settingReducer from "./settingReducer";
import conversationReducer from "./conversationReducer";
import accountReducer from "./accountReducer";
import dashboardReducer from "./dashboardReducer";
import liveChatReducer from "./liveChatReducer";
import queryZoiReducer from "./queryZoiReducer";
import intentReducer from "./intentReducer.js";
import journeyReducer from "./journeyReducer";

// Root Reducer
const rootReducer = combineReducers({
  login:loginReducer,
  header:headerReducer,
  assetLibrary:assetLibReducer,
  assetUpload:assetUploadReducer,
  dealRoomUpload:dealRoomUploadReducer,
  dealRoom:dealRoomReducer,
  crmLeads:crmReducer,
  chatAi: chatAiReducer,
  livechat: liveChatReducer,
  queryzoi: queryZoiReducer,
  account: accountReducer,
  setting:settingReducer,
  conversation:conversationReducer,
  intent:intentReducer,
  dashboard:dashboardReducer,
  journey:journeyReducer,
});

export default rootReducer;
